import React, { useEffect } from "react";
import styles from "./index.module.css";
import arrow from "../../../../../../assets/wall-icons/back_arrow.png";
import Product from "../Product/index";
import { useDispatch, useSelector } from "react-redux";
import { setIsPreviewCollectionOpened, setSelectedCollection } from "../../../../../../redux/slice/dashboardSlice";
import DefaultImg from "../../../../../Profile/DefaultImg";
import poweredByFaym from "../../../../../../assets/poweredByFaym.png";
import { useNavigate } from "react-router-dom";

const index = () => {
    const { selectedCollection, selectedScreen } = useSelector((state) => state.root.dashboard);
    const { user } = useSelector((state) => state.root.auth);
    const dispatch = useDispatch();
    const handleBack = () => {
        if (!selectedScreen) {
            dispatch(setSelectedCollection(null));
        }
        dispatch(setIsPreviewCollectionOpened(false));
    };
    const navigate = useNavigate();

    const handleClick = () => {
        navigate("/profile");
    };

    useEffect(() => {
        history.pushState(null, null, window.location.href);
        window.addEventListener("popstate", handleBack);

        return () => {
            window.removeEventListener("popstate", handleBack);
        };
    }, []);

    return (
        <div className={styles.collectionContainer}>
            <div className={styles.userWrapper}>
                <img src={arrow} alt="back icon" className={styles.backIcon} onClick={() => handleBack()} />
                <div className={styles.userName}>{user?.firstName}</div>
                {user?.profileImg !== "" ? (
                    <img src={user?.profileImg} alt="user profile pic" className={styles.profileImg} onClick={handleClick} />
                ) : (
                    <div className={styles.defaultImageContainer} onClick={handleClick}>
                        <DefaultImg width={"32px"} height={"auto"} fontSize={"14px"} radius={"50%"} />
                    </div>
                )}
            </div>
            <div className={styles.collectionDescripitionContainer}>
                <div className={styles.collectionHeading}>{selectedCollection?.title}</div>
            </div>
            <div className={styles.productsGrid}>
                {selectedCollection &&
                    selectedCollection.links.map((e, i) => {
                        return <Product key={i} productInfo={e} />;
                    })}
            </div>
            <img className={styles.faymBranding} src={poweredByFaym} />
        </div>
    );
};

export default index;
